import React from 'react';
import { User } from 'types/User';

interface Props {
  user: User;
}

/**
 * Provides the company name and number of team members
 */
export const CompanyLabel: React.FC<Props> = (props) => {
  const { user } = props;
  const userCurrentPlan = user.company?.pack_display_name;

  return (
    <div className="flex flex-col space-y-1">
      <h4 className="text-dark">{user.company?.name}</h4>
      <h5 className="">{user.teamMembers.length.toLocaleString()} users</h5>
      <h5> {userCurrentPlan} Plan</h5>
    </div>
  );
};
CompanyLabel.displayName = 'ContainerTracking.CompanyLabel';
